<template>
  <b-modal
    ref="dfCorrectionHistoryModal"
    size="xl"
    centered
    ok-only
    ok-title="ปิด"
    title="ประวัติการแก้ไข DF"
    @hidden="resetData"
  >
    <div class="mb-3">
      <strong>{{ currentItem.patientFullName }}</strong> -
      {{ currentItem.itemName }}
      <span class="text-muted ml-2">DN: {{ currentItem.dn }}</span>
    </div>

    <b-table
      :items="historyList"
      :fields="historyFields"
      :busy="isLoading"
      small
      head-variant="light"
      show-empty
      responsive
    >
      <template #cell(createdAt)="row">
        {{ formatDateTime(row.value) }}
      </template>
      <template #cell(correctedDf)="row">
        {{ row.value
        }}{{ row.item.correctedDfType === "PERCENT" ? "%" : " ฿" }}
      </template>
      <template #cell(correctedFinalDf)="row">
        {{ formatNumber(row.value) }}
      </template>
      <template #cell(correctedFinalCf)="row">
        {{ formatNumber(row.value) }}
      </template>
      <template #cell(correctedDoctorName)="row">
        {{ row.value || currentItem.doctorFullName || "-" }}
      </template>
      <template #empty>
        <p class="text-center text-muted my-2">ไม่มีประวัติการแก้ไข</p>
      </template>
      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner small class="mr-2" />กำลังโหลด...
        </div>
      </template>
    </b-table>
  </b-modal>
</template>

<script>
import moment from "moment";

export default {
  name: "DfCorrectionHistoryModal",
  data() {
    return {
      currentItem: {},
      historyList: [],
      isLoading: false,
      historyFields: [
        { key: "createdAt", label: "วันที่แก้ไข", sortable: true },
        { key: "correctedByName", label: "ผู้แก้ไข" },
        { key: "correctedDoctorName", label: "แพทย์ (แก้ไข)" },
        { key: "correctedDf", label: "DF ใหม่", class: "text-right" },
        {
          key: "correctedFinalDf",
          label: "Final DF",
          class: "text-right",
        },
        {
          key: "correctedFinalCf",
          label: "Final CF",
          class: "text-right",
        },
        { key: "remark", label: "หมายเหตุ" },
      ],
    };
  },
  methods: {
    async show(item) {
      this.currentItem = { ...item };
      this.$refs.dfCorrectionHistoryModal.show();
      this.isLoading = true;
      try {
        const res = await this.$store.dispatch(
          "moduleDfCorrection/fetchDfCorrectionHistory",
          {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            receiptId: item.receiptId || item.id,
            receiptItemId: item.receiptItemId,
          }
        );
        this.historyList = res.data || [];
      } catch (err) {
        this.historyList = [];
      } finally {
        this.isLoading = false;
      }
    },
    resetData() {
      this.currentItem = {};
      this.historyList = [];
    },
    formatDateTime(dt) {
      return dt ? moment(dt).locale("th").format("D MMM YY HH:mm") : "";
    },
    formatNumber(num) {
      return Math.round(num * 100) / 100;
    },
  },
};
</script>
